import dayjs from "dayjs";
import { IObservationData } from "../../utils/interfaces";
import { ObservationType } from "../../utils/types";

const generateBodyObservation = (
  objData: IObservationData,
  type: ObservationType
) => {
  let observationBody = {};

  switch (type) {
    case "pressure":
      observationBody = {
        resourceType: "Observation",
        status: "final",
        category: [
          {
            coding: [
              {
                system:
                  "http://terminology.hl7.org/CodeSystem/observation-category",
                code: "vital-signs",
                display: "Vital Signs",
              },
            ],
          },
        ],
        code: {
          coding: [
            {
              system: "http://loinc.org",
              code: "55284-4",
              display: "Blood pressure systolic and diastolic",
            },
          ],
          text: "Pressão Arterial Sistólica e Diastólica",
        },
        subject: {
          reference: `Patient/2.16.840.1.113883.13.237-${objData.patientID}`,
        },
        encounter: {
          reference: `Encounter/${objData.encounterID}`, //34156
        },
        effectiveDateTime: dayjs().toISOString(),
        component: [
          {
            code: {
              coding: [
                {
                  system: "http://loinc.org",
                  code: "8480-6",
                  display: "Systolic blood pressure",
                },
              ],
              text: "Pressão Arterial Sistólica",
            },
            valueQuantity: {
              value: objData.pressure.sistolic,
              unit: "mm[Hg]",
              system: "http://unitsofmeasure.org",
              code: "mm[Hg]",
            },
          },
          {
            code: {
              coding: [
                {
                  system: "http://loinc.org",
                  code: "8462-4",
                  display: "Diastolic blood pressure",
                },
              ],
              text: "Pressão Arterial Diastólica",
            },
            valueQuantity: {
              value: objData.pressure.diastolic,
              unit: "mm[Hg]",
              system: "http://unitsofmeasure.org",
              code: "mm[Hg]",
            },
          },
        ],
      };
      break;
    case "bodyWeight":
      observationBody = {
        resourceType: "Observation",
        status: "final",
        category: [
          {
            coding: [
              {
                system:
                  "http://terminology.hl7.org/CodeSystem/observation-category",
                code: "vital-signs",
                display: "Vital Signs",
              },
            ],
          },
        ],
        code: {
          coding: [
            {
              system: "http://loinc.org",
              code: "29463-7",
              display: "Body weight",
            },
          ],
          text: "Peso",
        },
        subject: {
          reference: `Patient/2.16.840.1.113883.13.237-${objData.patientID}`,
        },
        encounter: {
          reference: `Encounter/${objData.encounterID}`,
        },
        effectiveDateTime: dayjs().toISOString(),
        valueQuantity: {
          value: objData.bodyWeight,
          unit: "kg",
          system: "http://unitsofmeasure.org",
          code: "kg",
        },
      };
      break;
    case "bodyHeight":
      observationBody = {
        resourceType: "Observation",
        status: "final",
        category: [
          {
            coding: [
              {
                system:
                  "http://terminology.hl7.org/CodeSystem/observation-category",
                code: "vital-signs",
                display: "Vital Signs",
              },
            ],
          },
        ],
        code: {
          coding: [
            {
              system: "http://loinc.org",
              code: "8302-2",
              display: "Body height",
            },
          ],
          text: "Altura",
        },
        subject: {
          reference: `Patient/2.16.840.1.113883.13.237-${objData.patientID}`,
        },
        encounter: {
          reference: `Encounter/${objData.encounterID}`,
        },
        effectiveDateTime: dayjs().toISOString(),
        valueQuantity: {
          value: objData.bodyHeight,
          unit: "cm",
          system: "http://unitsofmeasure.org",
          code: "cm",
        },
      };
      break;
    case "abdominalCircumference":
      observationBody = {
        resourceType: "Observation",
        status: "final",
        category: [
          {
            coding: [
              {
                system:
                  "http://terminology.hl7.org/CodeSystem/observation-category",
                code: "vital-signs",
                display: "Vital Signs",
              },
            ],
          },
        ],
        code: {
          coding: [
            {
              system: "http://loinc.org",
              code: "8280-0",
              display: "Waist Circumference at umbilicus by Tape measure",
            },
          ],
          text: "Circunferência Abdominal",
        },
        subject: {
          reference: `Patient/2.16.840.1.113883.13.237-${objData.patientID}`,
        },
        encounter: {
          reference: `Encounter/${objData.encounterID}`,
        },
        effectiveDateTime: dayjs().toISOString(),
        valueQuantity: {
          value: objData.abdominalCircumference,
          unit: "cm",
          system: "http://unitsofmeasure.org",
          code: "cm",
        },
      };
      break;
    case "headCircumference":
      observationBody = {
        resourceType: "Observation",
        status: "final",
        category: [
          {
            coding: [
              {
                system:
                  "http://terminology.hl7.org/CodeSystem/observation-category",
                code: "vital-signs",
                display: "Vital Signs",
              },
            ],
          },
        ],
        code: {
          coding: [
            {
              system: "http://loinc.org",
              code: "9843-4",
              display: "Head Occipital-frontal circumference",
            },
          ],
          text: "Perímetro Cefálico",
        },
        subject: {
          reference: `Patient/2.16.840.1.113883.13.237-${objData.patientID}`,
        },
        encounter: {
          reference: `Encounter/${objData.encounterID}`,
        },
        effectiveDateTime: dayjs().toISOString(),
        valueQuantity: {
          value: objData.headCircumference,
          unit: "cm",
          system: "http://unitsofmeasure.org",
          code: "cm",
        },
      };
      break;
    case "neckCircumference":
      observationBody = {
        resourceType: "Observation",
        status: "final",
        category: [
          {
            coding: [
              {
                system:
                  "http://terminology.hl7.org/CodeSystem/observation-category",
                code: "vital-signs",
                display: "Vital Signs",
              },
            ],
          },
        ],
        code: {
          coding: [
            {
              system: "http://loinc.org",
              code: "56074-8",
              display: "Circumference Neck",
            },
          ],
          text: "Circunferência pescoço",
        },
        subject: {
          reference: `Patient/2.16.840.1.113883.13.237-${objData.patientID}`,
        },
        encounter: {
          reference: `Encounter/${objData.encounterID}`,
        },
        effectiveDateTime: dayjs().toISOString(),
        valueQuantity: {
          value: objData.neckCircumference,
          unit: "cm",
          system: "http://unitsofmeasure.org",
          code: "cm",
        },
      };
      break;
    case "calfCircumference":
      observationBody = {
        resourceType: "Observation",
        status: "final",
        category: [
          {
            coding: [
              {
                system:
                  "http://terminology.hl7.org/CodeSystem/observation-category",
                code: "vital-signs",
                display: "Vital Signs",
              },
            ],
          },
        ],
        code: {
          coding: [
            {
              system: "http://loinc.org",
              code: "107112-5",
              display: "Calf circumference in cm",
            },
          ],
          text: "Circunferência panturrilhas",
        },
        subject: {
          reference: `Patient/2.16.840.1.113883.13.237-${objData.patientID}`,
        },
        encounter: {
          reference: `Encounter/${objData.encounterID}`,
        },
        effectiveDateTime: dayjs().toISOString(),
        valueQuantity: {
          value: objData.calfCircumference,
          unit: "cm",
          system: "http://unitsofmeasure.org",
          code: "cm",
        },
      };
      break;
    case "bodyFatPercentage":
      observationBody = {
        resourceType: "Observation",
        status: "final",
        category: [
          {
            coding: [
              {
                system:
                  "http://terminology.hl7.org/CodeSystem/observation-category",
                code: "vital-signs",
                display: "Vital Signs",
              },
            ],
          },
        ],
        code: {
          coding: [
            {
              system: "http://loinc.org",
              code: "41982-0",
              display: "Percentage of body fat Measured",
            },
          ],
          text: "Percentual de gordura",
        },
        subject: {
          reference: `Patient/2.16.840.1.113883.13.237-${objData.patientID}`,
        },
        encounter: {
          reference: `Encounter/${objData.encounterID}`,
        },
        effectiveDateTime: dayjs().toISOString(),
        valueQuantity: {
          value: objData.bodyFatPercentage,
          unit: "%",
          system: "http://unitsofmeasure.org",
          code: "%",
        },
      };
      break;
    case "alcoholic":
      observationBody = {
        resourceType: "Observation",
        status: "final",
        category: [
          {
            coding: [
              {
                system:
                  "http://terminology.hl7.org/CodeSystem/observation-category",
                code: "social-history",
                display: "Social History",
              },
            ],
          },
        ],
        code: {
          coding: [
            {
              system: "http://loinc.org",
              code: "74013-4",
              display: "Alcoholic drinks per day",
            },
          ],
          text: "Consumo diário de álcool",
        },
        subject: {
          reference: `Patient/2.16.840.1.113883.13.237-${objData.patientID}`,
        },
        encounter: {
          reference: `Encounter/${objData.encounterID}`,
        },
        effectiveDateTime: dayjs().toISOString(),
        valueQuantity: {
          value: objData.alcoholic,
          system: "http://unitsofmeasure.org",
          code: "ml/d",
        },
      };
      break;
    case "alcoholicType":
      {
        const selectedCodeable = Array.isArray(objData?.alcoholicType)
          ? objData?.alcoholicType?.[0]
          : objData?.alcoholicType;

        observationBody = {
          resourceType: "Observation",
          status: "final",
          category: [
            {
              coding: [
                {
                  system:
                    "http://terminology.hl7.org/CodeSystem/observation-category",
                  code: "social-history",
                  display: "Social History",
                },
              ],
            },
          ],
          code: {
            coding: [
              {
                system: "http://loinc.org",
                code: "74013-4",
                display: "Alcoholic drinks per day",
              },
            ],
            text: "Consumo diário de álcool",
          },
          subject: {
            reference: `Patient/2.16.840.1.113883.13.237-${objData.patientID}`,
          },
          encounter: {
            reference: `Encounter/${objData.encounterID}`,
          },
          effectiveDateTime: dayjs().toISOString(),
          valueCodeableConcept: {
            coding: [
              {
                system: "http://loinc.org",
                code: selectedCodeable?.code,
                display: selectedCodeable?.display,
              },
            ],
            text: selectedCodeable?.value,
          },
        };
      }
      break;
    case "beerIntake24h":
    case "distilledAlcoholIntake24h":
    case "wineIntake24h":
      {
        const fallbackMap: Record<string, { code: string; display: string }> = {
          beerIntake24h: {
            code: "80450-0",
            display: "Beer intake 24 hour",
          },
          distilledAlcoholIntake24h: {
            code: "80478-1",
            display: "Distilled alcohol intake 24 hour",
          },
          wineIntake24h: {
            code: "80479-9",
            display: "Wine intake 24 hour",
          },
        };

        const selectedType = Array.isArray(objData?.alcoholicType)
          ? objData?.alcoholicType?.[0]
          : objData?.alcoholicType;
        const mappedType = fallbackMap[type] || fallbackMap.beerIntake24h;
        const observationDisplay =
          selectedType?.display || mappedType.display;
        const observationCode = selectedType?.code || mappedType.code;
        const observationSystem = selectedType?.system || "http://loinc.org";
        const observationUnit = selectedType?.unit || "mL/(24.h)";
        const alcoholValue = Number(objData?.alcoholic);
        const normalizedValue = Number.isNaN(alcoholValue)
          ? undefined
          : alcoholValue;

        observationBody = {
          resourceType: "Observation",
          status: "final",
          category: [
            {
              coding: [
                {
                  system:
                    "http://terminology.hl7.org/CodeSystem/observation-category",
                  code: "social-history",
                  display: "Social History",
                },
              ],
            },
          ],
          code: {
            coding: [
              {
                system: observationSystem,
                code: observationCode,
                display: observationDisplay,
              },
            ],
            text: observationDisplay,
          },
          subject: {
            reference: `Patient/2.16.840.1.113883.13.237-${objData.patientID}`,
          },
          encounter: {
            reference: `Encounter/${objData.encounterID}`,
          },
          effectiveDateTime: dayjs().toISOString(),
          valueQuantity: {
            ...(normalizedValue !== undefined && { value: normalizedValue }),
            unit: observationUnit,
            system: "http://unitsofmeasure.org",
            code: observationUnit,
          },
        };
      }
      break;
    case "alcoholFrequency":
      observationBody = {
        resourceType: "Observation",
        status: "final",
        category: [
          {
            coding: [
              {
                system:
                  "http://terminology.hl7.org/CodeSystem/observation-category",
                code: "social-history",
                display: "Social History",
              },
            ],
          },
        ],
        code: {
          coding: [
            {
              system: "http://loinc.org",
              code: "68518-0",
              display: "How often do you have a drink containing alcohol",
            },
          ],
          text: "Frequência de consumo de álcool",
        },
        subject: {
          reference: `Patient/2.16.840.1.113883.13.237-${objData.patientID}`,
        },
        encounter: {
          reference: `Encounter/${objData.encounterID}`,
        },
        effectiveDateTime: dayjs().toISOString(),
        valueCodeableConcept: {
          coding: [
            {
              system: "http://loinc.org",
              code: objData?.alcoholFrequency?.code,
              display: objData?.alcoholFrequency?.value,
            },
          ],
          text: objData?.alcoholFrequency?.display,
        },
      };
      break;
    case "smoking":
      observationBody = {
        resourceType: "Observation",
        status: "final",
        category: [
          {
            coding: [
              {
                system:
                  "http://terminology.hl7.org/CodeSystem/observation-category",
                code: "social-history",
                display: "Social History",
              },
            ],
          },
        ],
        code: {
          coding: [
            {
              system: "http://loinc.org",
              code: "72166-2",
              display: "Tobacco smoking status",
            },
          ],
          text: "Tabagismo",
        },
        subject: {
          reference: `Patient/2.16.840.1.113883.13.237-${objData.patientID}`,
        },
        encounter: {
          reference: `Encounter/${objData.encounterID}`,
        },
        effectiveDateTime: dayjs().toISOString(),
        valueCodeableConcept: {
          coding: [
            {
              system: "http://loinc.org",
              code: objData.smoking?.code,
              display: objData.smoking?.display,
            },
          ],
          text: objData.smoking?.value,
        },
      };
      break;
    case "drugTypeLifetime":
      {
        const selectedDrugType = Array.isArray(objData?.drugTypeLifetime)
          ? objData?.drugTypeLifetime?.[0]
          : objData?.drugTypeLifetime;

        if (!selectedDrugType || !selectedDrugType.code || selectedDrugType.code === "") {
          return null;
        }

        observationBody = {
          resourceType: "Observation",
          status: "final",
          category: [
            {
              coding: [
                {
                  system:
                    "http://terminology.hl7.org/CodeSystem/observation-category",
                  code: "social-history",
                  display: "Social History",
                },
              ],
            },
          ],
          code: {
            coding: [
              {
                system: "http://loinc.org",
                code: "63643-1",
                display: "Drug type used in your lifetime",
              },
            ],
            text: "Tipo de droga usado na sua vida",
          },
          subject: {
            reference: `Patient/2.16.840.1.113883.13.237-${objData.patientID}`,
          },
          encounter: {
            reference: `Encounter/${objData.encounterID}`,
          },
          effectiveDateTime: dayjs().toISOString(),
          valueCodeableConcept: {
            coding: [
              {
                system: "http://loinc.org",
                code: selectedDrugType?.code,
                display: selectedDrugType?.display,
              },
            ],
            text: selectedDrugType?.label || selectedDrugType?.value,
          },
        };
      }
      break;
    case "drugFrequencyPast12Months":
      {
        if (!objData?.drugFrequencyPast12Months || !objData?.drugFrequencyPast12Months?.code || objData?.drugFrequencyPast12Months?.code === "") {
          return null;
        }

        observationBody = {
          resourceType: "Observation",
          status: "final",
          category: [
            {
              coding: [
                {
                  system:
                    "http://terminology.hl7.org/CodeSystem/observation-category",
                  code: "social-history",
                  display: "Social History",
                },
              ],
            },
          ],
          code: {
            coding: [
              {
                system: "http://loinc.org",
                code: "96843-8",
                display: "How often have you used illegal or recreational drugs in past 12 months",
              },
            ],
            text: "Quantas vezes você usou drogas ilícitas ou recreativas nos últimos 12 meses",
          },
          subject: {
            reference: `Patient/2.16.840.1.113883.13.237-${objData.patientID}`,
          },
          encounter: {
            reference: `Encounter/${objData.encounterID}`,
          },
          effectiveDateTime: dayjs().toISOString(),
          valueCodeableConcept: {
            coding: [
              {
                system: "http://loinc.org",
                code: objData?.drugFrequencyPast12Months?.code,
                display: objData?.drugFrequencyPast12Months?.value,
              },
            ],
            text: objData?.drugFrequencyPast12Months?.display,
          },
        };
      }
      break;
    case "exerciseDaysPerWeek":
      {
        const exerciseDays = objData?.exerciseDaysPerWeek?.value
          ? Number(objData.exerciseDaysPerWeek.value)
          : undefined;

        if (exerciseDays === undefined || isNaN(exerciseDays)) {
          return null;
        }

        observationBody = {
          resourceType: "Observation",
          status: "final",
          category: [
            {
              coding: [
                {
                  system:
                    "http://terminology.hl7.org/CodeSystem/observation-category",
                  code: "social-history",
                  display: "Social History",
                },
              ],
            },
          ],
          code: {
            coding: [
              {
                system: "http://loinc.org",
                code: "68515-6",
                display: "Days per week of moderate to strenuous exercise",
              },
            ],
            text: "Dias por semana de exercício moderado a intenso",
          },
          subject: {
            reference: `Patient/2.16.840.1.113883.13.237-${objData.patientID}`,
          },
          encounter: {
            reference: `Encounter/${objData.encounterID}`,
          },
          effectiveDateTime: dayjs().toISOString(),
          valueQuantity: {
            value: exerciseDays,
            unit: "d/wk",
            system: "http://unitsofmeasure.org",
            code: "d/wk",
          },
        };
      }
      break;
    case "exerciseMinutesPerDay":
      {
        const exerciseMinutes = objData?.exerciseMinutesPerDay
          ? Number(objData.exerciseMinutesPerDay)
          : undefined;

        if (exerciseMinutes === undefined || isNaN(exerciseMinutes)) {
          return null;
        }

        observationBody = {
          resourceType: "Observation",
          status: "final",
          category: [
            {
              coding: [
                {
                  system:
                    "http://terminology.hl7.org/CodeSystem/observation-category",
                  code: "social-history",
                  display: "Social History",
                },
              ],
            },
          ],
          code: {
            coding: [
              {
                system: "http://loinc.org",
                code: "68516-4",
                display: "Minutes of moderate to strenuous exercise on days exercised",
              },
            ],
            text: "Minutos de exercício moderado a intenso nos dias exercitados",
          },
          subject: {
            reference: `Patient/2.16.840.1.113883.13.237-${objData.patientID}`,
          },
          encounter: {
            reference: `Encounter/${objData.encounterID}`,
          },
          effectiveDateTime: dayjs().toISOString(),
          valueQuantity: {
            value: exerciseMinutes,
            unit: "min",
            system: "http://unitsofmeasure.org",
            code: "min",
          },
        };
      }
      break;
    case "physicalActivityTypePhenX":
      {
        const selectedActivityType = Array.isArray(objData?.physicalActivityTypePhenX)
          ? objData?.physicalActivityTypePhenX?.[0]
          : objData?.physicalActivityTypePhenX;

        if (!selectedActivityType || !selectedActivityType.code || selectedActivityType.code === "") {
          return null;
        }

        observationBody = {
          resourceType: "Observation",
          status: "final",
          category: [
            {
              coding: [
                {
                  system:
                    "http://terminology.hl7.org/CodeSystem/observation-category",
                  code: "social-history",
                  display: "Social History",
                },
              ],
            },
          ],
          code: {
            coding: [
              {
                system: "http://loinc.org",
                code: "81685-9",
                display: "Type of physical activity (PhenX)",
              },
            ],
            text: "Tipo de atividade física (PhenX)",
          },
          subject: {
            reference: `Patient/2.16.840.1.113883.13.237-${objData.patientID}`,
          },
          encounter: {
            reference: `Encounter/${objData.encounterID}`,
          },
          effectiveDateTime: dayjs().toISOString(),
          valueCodeableConcept: {
            coding: [
              {
                system: "http://loinc.org",
                code: selectedActivityType?.code,
                display: selectedActivityType?.display,
              },
            ],
            text: selectedActivityType?.label || selectedActivityType?.value,
          },
        };
      }
      break;
    case "usualActivityIntensityPhenX":
      {
        if (!objData?.usualActivityIntensityPhenX || !objData?.usualActivityIntensityPhenX?.code || objData?.usualActivityIntensityPhenX?.code === "") {
          return null;
        }

        observationBody = {
          resourceType: "Observation",
          status: "final",
          category: [
            {
              coding: [
                {
                  system:
                    "http://terminology.hl7.org/CodeSystem/observation-category",
                  code: "social-history",
                  display: "Social History",
                },
              ],
            },
          ],
          code: {
            coding: [
              {
                system: "http://loinc.org",
                code: "89555-7",
                display: "Usual activity intensity (PhenX)",
              },
            ],
            text: "Intensidade usual da atividade (PhenX)",
          },
          subject: {
            reference: `Patient/2.16.840.1.113883.13.237-${objData.patientID}`,
          },
          encounter: {
            reference: `Encounter/${objData.encounterID}`,
          },
          effectiveDateTime: dayjs().toISOString(),
          valueCodeableConcept: {
            coding: [
              {
                system: "http://loinc.org",
                code: objData?.usualActivityIntensityPhenX?.code,
                display: objData?.usualActivityIntensityPhenX?.value,
              },
            ],
            text: objData?.usualActivityIntensityPhenX?.display,
          },
        };
      }
      break;
    case "menstrualPeriod":
      observationBody = {
        resourceType: "Observation",
        status: "final",
        category: [
          {
            coding: [
              {
                system:
                  "http://terminology.hl7.org/CodeSystem/observation-category",
                code: "vital-signs",
                display: "Vital Signs",
              },
            ],
          },
        ],
        code: {
          coding: [
            {
              system: "http://loinc.org",
              code: "8665-2",
              display: "Last menstrual period start date observation",
            },
          ],
          text: "Data da Última Menstruação",
        },
        subject: {
          reference: `Patient/2.16.840.1.113883.13.237-${objData.patientID}`,
        },
        encounter: {
          reference: `Encounter/${objData.encounterID}`,
        },
        effectiveDateTime: dayjs().toISOString(),
        valueDateTime: dayjs(objData.menstrualPeriod).toISOString(),
      };
      break;
    case "pregnancies":
      observationBody = {
        resourceType: "Observation",
        status: "final",
        category: [
          {
            coding: [
              {
                system:
                  "http://terminology.hl7.org/CodeSystem/observation-category",
                code: "vital-signs",
                display: "Vital Signs",
              },
            ],
          },
        ],
        code: {
          coding: [
            {
              system: "http://loinc.org",
              code: "11996-6",
              display: "[#] Pregnancies",
            },
          ],
          text: "Quantidade de Gestações",
        },
        subject: {
          reference: `Patient/2.16.840.1.113883.13.237-${objData.patientID}`,
        },
        encounter: {
          reference: `Encounter/${objData.encounterID}`,
        },
        effectiveDateTime: dayjs().toISOString(),
        valueQuantity: {
          value: objData.pregnancies,
        },
      };
      break;
    case "abortions":
      observationBody = {
        resourceType: "Observation",
        status: "final",
        category: [
          {
            coding: [
              {
                system:
                  "http://terminology.hl7.org/CodeSystem/observation-category",
                code: "vital-signs",
                display: "Vital Signs",
              },
            ],
          },
        ],
        code: {
          coding: [
            {
              system: "http://loinc.org",
              code: "11612-9",
              display: "[#] Abortions",
            },
          ],
          text: "Quantidade de Abortos",
        },
        subject: {
          reference: `Patient/2.16.840.1.113883.13.237-${objData.patientID}`,
        },
        encounter: {
          reference: `Encounter/${objData.encounterID}`,
        },
        effectiveDateTime: dayjs().toISOString(),
        valueQuantity: {
          value: objData.abortions, //Adicionar do formulário
        },
      };
      break;
    case "birthsTotal":
      observationBody = {
        resourceType: "Observation",
        status: "final",
        category: [
          {
            coding: [
              {
                system:
                  "http://terminology.hl7.org/CodeSystem/observation-category",
                code: "vital-signs",
                display: "Vital Signs",
              },
            ],
          },
        ],
        code: {
          coding: [
            {
              system: "http://loinc.org",
              code: "11640-0",
              display: "[#] Births total", //Adicionar do formulário
            },
          ],
          text: "Partos",
        },
        subject: {
          reference: `Patient/2.16.840.1.113883.13.237-${objData.patientID}`,
        },
        encounter: {
          reference: `Encounter/${objData.encounterID}`,
        },
        effectiveDateTime: dayjs().toISOString(),
        valueQuantity: {
          value: objData.birthsTotal, //Adicionar do formulário
        },
      };
      break;
    case "breastfeeding":
      observationBody = {
        resourceType: "Observation",
        status: "final",
        category: [
          {
            coding: [
              {
                system:
                  "http://terminology.hl7.org/CodeSystem/observation-category",
                code: "vital-signs",
                display: "Vital Signs",
              },
            ],
          },
        ],
        code: {
          coding: [
            {
              system: "http://loinc.org",
              code: "63895-7",
              display: "Breastfeeding status",
            },
          ],
          text: "Tipo de Aleitamento Materno",
        },
        subject: {
          reference: `Patient/2.16.840.1.113883.13.237-${objData.patientID}`,
        },
        encounter: {
          reference: `Encounter/${objData.encounterID}`,
        },
        effectiveDateTime: dayjs().toISOString(),
        valueCodeableConcept: {
          coding: [
            {
              system:
                "http://www.saude.gov.br/fhir/r4/CodeSystem/BRTipoAleitamentoMaterno",
              code: objData.breastfeeding?.value, //Colocar code
              display: objData.breastfeeding?.display, // Colocar display
            },
          ],
        },
      };
      break;
    case "ageGestacional":
      observationBody = {
        resourceType: "Observation",
        status: "final",
        category: [
          {
            coding: [
              {
                system:
                  "http://terminology.hl7.org/CodeSystem/observation-category",
                code: "vital-signs",
                display: "Vital Signs",
              },
            ],
          },
        ],
        code: {
          coding: [
            {
              system: "http://loinc.org",
              code: "11885-1",
              display:
                "Gestational age estimate based on date of first day of last menstrual period",
            },
          ],
          text: "Idade Gestacional",
        },
        subject: {
          reference: `Patient/2.16.840.1.113883.13.237-${objData.patientID}`,
        },
        encounter: {
          reference: `Encounter/${objData.encounterID}`,
        },
        effectiveDateTime: dayjs().toISOString(),
        valueQuantity: {
          value: objData.ageGestacional,
          unit: "week", //Colocar as opções de meses ou semanas
          system: "http://unitsofmeasure.org",
          code: "wk", //Alterar aqui tbm
        },
      };
      break;
    case "temperature":
      observationBody = {
        resourceType: "Observation",
        meta: {
          profile: [
            "http://fluxmed.com.br/fhir/r5/StructureDefinition/FM-Observation",
          ],
        },
        status: "final",
        category: [
          {
            coding: [
              {
                system:
                  "http://terminology.hl7.org/CodeSystem/observation-category",
                code: "vital-signs",
                display: "Vital Signs",
              },
            ],
          },
        ],
        code: {
          coding: [
            {
              system: "http://loinc.org",
              code: "8310-5",
              display: "Temperatura corporal",
            },
          ],
          text: "Temperatura corporal",
        },
        subject: {
          reference: `Patient/2.16.840.1.113883.13.237-${objData.patientID}`,
        },
        encounter: {
          reference: `Encounter/${objData.encounterID}`,
        },
        effectiveDateTime: dayjs().toISOString(),
        performer: [
          {
            reference: `Practitioner/2.16.840.1.113883.13.237-${objData.practitionerID}`,
            display: `${objData.practitionerName}`,
          },
        ],
        valueQuantity: {
          value: objData.temperature,
          unit: "Cel",
          system: "http://unitsofmeasure.org",
          code: "Cel",
        },
      };
      break;
    case "pain":
      observationBody = {
        resourceType: "Observation",
        meta: {
          profile: [
            "http://fluxmed.com.br/fhir/r5/StructureDefinition/FM-Observation",
          ],
        },
        status: "final",
        category: [
          {
            coding: [
              {
                system:
                  "http://terminology.hl7.org/CodeSystem/observation-category",
                code: "survey",
                display: "Survey",
              },
            ],
          },
        ],
        code: {
          coding: [
            {
              system: "http://loinc.org",
              code: "72514-3",
              display:
                "Pain severity - 0-10 verbal numeric rating [Score] - Reported",
            },
          ],
          text: "Dor",
        },
        subject: {
          reference: `Patient/2.16.840.1.113883.13.237-${objData.patientID}`,
        },
        encounter: {
          reference: `Encounter/${objData.encounterID}`,
        },
        effectiveDateTime: dayjs().toISOString(),
        performer: [
          {
            reference: `Practitioner/2.16.840.1.113883.13.237-${objData.practitionerID}`,
            display: `${objData.practitionerName}`,
          },
        ],
        valueInteger: objData.pain,
      };
      break;
    case "cardiacRate":
      observationBody = {
        resourceType: "Observation",
        meta: {
          profile: [
            "http://fluxmed.com.br/fhir/r5/StructureDefinition/FM-Observation",
          ],
        },
        status: "final",
        category: [
          {
            coding: [
              {
                system:
                  "http://terminology.hl7.org/CodeSystem/observation-category",
                code: "vital-signs",
                display: "Vital Signs",
              },
            ],
          },
        ],
        code: {
          coding: [
            {
              system: "http://loinc.org",
              code: "8867-4",
              display: "Frequência cardíaca",
            },
          ],
          text: "Frequência cardíaca",
        },
        subject: {
          reference: `Patient/2.16.840.1.113883.13.237-${objData.patientID}`,
        },
        encounter: {
          reference: `Encounter/${objData.encounterID}`,
        },
        effectiveDateTime: dayjs().toISOString(),
        performer: [
          {
            reference: `Practitioner/2.16.840.1.113883.13.237-${objData.practitionerID}`,
            display: `${objData.practitionerName}`,
          },
        ],
        valueQuantity: {
          value: objData.cardiacRate,
          unit: "/min",
          system: "http://unitsofmeasure.org",
          code: "/min",
        },
      };
      break;
    case "respiratoryRate":
      observationBody = {
        resourceType: "Observation",
        meta: {
          profile: [
            "http://fluxmed.com.br/fhir/r5/StructureDefinition/FM-Observation",
          ],
        },
        status: "final",
        category: [
          {
            coding: [
              {
                system:
                  "http://terminology.hl7.org/CodeSystem/observation-category",
                code: "vital-signs",
                display: "Vital Signs",
              },
            ],
          },
        ],
        code: {
          coding: [
            {
              system: "http://loinc.org",
              code: "9279-1",
              display: "Frequência respiratória",
            },
          ],
          text: "Frequência respiratória",
        },
        subject: {
          reference: `Patient/2.16.840.1.113883.13.237-${objData.patientID}`,
        },
        encounter: {
          reference: `Encounter/${objData.encounterID}`,
        },
        effectiveDateTime: dayjs().toISOString(),
        performer: [
          {
            reference: `Practitioner/2.16.840.1.113883.13.237-${objData.practitionerID}`,
            display: `${objData.practitionerName}`,
          },
        ],
        valueQuantity: {
          value: objData.respiratoryRate,
          unit: "/min",
          system: "http://unitsofmeasure.org",
          code: "/min",
        },
      };
      break;
    case "glicemiaCapilar":
      observationBody = {
        resourceType: "Observation",
        meta: {
          profile: [
            "http://fluxmed.com.br/fhir/r5/StructureDefinition/FM-Observation",
          ],
        },
        status: "final",
        category: [
          {
            coding: [
              {
                system:
                  "http://terminology.hl7.org/CodeSystem/observation-category",
                code: "exam",
                display: "Exam",
              },
            ],
          },
        ],
        code: {
          coding: [
            {
              system:
                "https://terminologia.saude.gov.br/fhir/CodeSystem/BRCBHPMTUSS",
              code: "40302040",
              display: "Glicose - pesquisa e/ou dosagem",
            },
          ],
          text: "Glicemia Capilar",
        },
        subject: {
          reference: `Patient/2.16.840.1.113883.13.237-${objData.patientID}`,
        },
        encounter: {
          reference: `Encounter/${objData.encounterID}`,
        },
        effectiveDateTime: dayjs().toISOString(),
        performer: [
          {
            reference: `Practitioner/2.16.840.1.113883.13.237-${objData.practitionerID}`,
            display: `${objData.practitionerName}`,
          },
        ],
        valueQuantity: {
          value: objData.glicemiaCapilar,
          unit: "mg/dL",
          system: "http://unitsofmeasure.org",
          code: "mg/dL",
        },
      };
      break;
    case "spo2":
      observationBody = {
        resourceType: "Observation",
        meta: {
          profile: [
            "http://fluxmed.com.br/fhir/r5/StructureDefinition/FM-Observation",
          ],
        },
        status: "final",
        category: [
          {
            coding: [
              {
                system:
                  "http://terminology.hl7.org/CodeSystem/observation-category",
                code: "vital-signs",
                display: "Vital Signs",
              },
            ],
          },
        ],
        code: {
          coding: [
            {
              system: "http://loinc.org",
              code: "59408-5",
              display: "Oxygen saturation in Arterial blood by Pulse oximetry",
            },
          ],
          text: "Saturação de Oxigênio (SpO2)",
        },
        subject: {
          reference: `Patient/2.16.840.1.113883.13.237-${objData.patientID}`,
        },
        encounter: {
          reference: `Encounter/${objData.encounterID}`,
        },
        effectiveDateTime: dayjs().toISOString(),
        performer: [
          {
            reference: `Practitioner/2.16.840.1.113883.13.237-${objData.practitionerID}`,
            display: `${objData.practitionerName}`,
          },
        ],
        valueQuantity: {
          value: objData.spo2,
          unit: "%",
          system: "http://unitsofmeasure.org",
          code: "%",
        },
      };
      break;
    case "bodyMassIndex":
      observationBody = {
        resourceType: "Observation",
        meta: {
          profile: [
            "http://fluxmed.com.br/fhir/r5/StructureDefinition/FM-Observation",
          ],
        },
        status: "final",
        category: [
          {
            coding: [
              {
                system:
                  "http://terminology.hl7.org/CodeSystem/observation-category",
                code: "body-mass-index",
                display: "Body Mass Index",
              },
            ],
          },
        ],
        code: {
          coding: [
            {
              system: "http://loinc.org",
              code: "39156-5",
              display: "Body mass index (BMI)",
            },
          ],
          text: "Índice de Massa Corporal",
        },
        subject: {
          reference: `Patient/2.16.840.1.113883.13.237-${objData.patientID}`,
        },
        encounter: {
          reference: `Encounter/${objData.encounterID}`,
        },
        effectiveDateTime: dayjs().toISOString(),
        valueQuantity: {
          value: objData.bodyMassIndex,
          unit: "kg/m²",
          system: "http://unitsofmeasure.org",
          code: "kg/m²",
        },
      };
      break;
    case "Queixa principal":
      observationBody = {
        resourceType: "Observation",
        meta: {
          profile: [
            "http://fluxmed.com.br/fhir/r5/StructureDefinition/FM-Observation",
          ],
        },
        status: "final",
        code: {
          coding: [
            {
              system: "http://loinc.org",
              code: "10154-3",
              display: "Chief complaint Narrative - Reported",
            },
          ],
          text: "Queixa principal",
        },
        subject: {
          reference: `Patient/2.16.840.1.113883.13.237-${objData.patientID}`,
        },
        encounter: {
          reference: `Encounter/${objData.encounterID}`,
        },
        issued: dayjs().toISOString(),
        performer: [
          {
            reference: `Practitioner/2.16.840.1.113883.13.237-${objData.practitionerID}`,
            display: `${objData.practitionerName}`,
          },
        ],
        valueString: objData["Queixa principal"],
      };
      break;
    case "História da doença atual":
      observationBody = {
        resourceType: "Observation",
        meta: {
          profile: [
            "http://fluxmed.com.br/fhir/r5/StructureDefinition/FM-Observation",
          ],
        },
        status: "final",
        code: {
          coding: [
            {
              system: "http://loinc.org",
              code: "10164-2",
              display: "History of Present illness Narrative",
            },
          ],
          text: "História da doença atual",
        },
        subject: {
          reference: `Patient/2.16.840.1.113883.13.237-${objData.patientID}`,
        },
        encounter: {
          reference: `Encounter/${objData.encounterID}`,
        },
        issued: dayjs().toISOString(),
        performer: [
          {
            reference: `Practitioner/2.16.840.1.113883.13.237-${objData.practitionerID}`,
            display: `${objData.practitionerName}`,
          },
        ],
        valueString: objData["História da doença atual"],
      };
      break;
    case "História patológica pregressa":
      observationBody = {
        resourceType: "Observation",
        meta: {
          profile: [
            "http://fluxmed.com.br/fhir/r5/StructureDefinition/FM-Observation",
          ],
        },
        status: "final",
        code: {
          coding: [
            {
              system: "http://loinc.org",
              code: "11348-0",
              display: "History of Past illness Narrative",
            },
          ],
          text: "História patológica pregressa",
        },
        subject: {
          reference: `Patient/2.16.840.1.113883.13.237-${objData.patientID}`,
        },
        encounter: {
          reference: `Encounter/${objData.encounterID}`,
        },
        issued: dayjs().toISOString(),
        performer: [
          {
            reference: `Practitioner/2.16.840.1.113883.13.237-${objData.practitionerID}`,
            display: `${objData.practitionerName}`,
          },
        ],
        valueString: objData["História patológica pregressa"],
      };
      break;
    case "História pessoal e social":
      observationBody = {
        resourceType: "Observation",
        meta: {
          profile: [
            "http://fluxmed.com.br/fhir/r5/StructureDefinition/FM-Observation",
          ],
        },
        status: "final",
        code: {
          coding: [
            {
              system: "http://loinc.org",
              code: "29762-2",
              display: "Social history Narrative",
            },
          ],
          text: "História pessoal e social",
        },
        subject: {
          reference: `Patient/2.16.840.1.113883.13.237-${objData.patientID}`,
        },
        encounter: {
          reference: `Encounter/${objData.encounterID}`,
        },
        issued: dayjs().toISOString(),
        performer: [
          {
            reference: `Practitioner/2.16.840.1.113883.13.237-${objData.practitionerID}`,
            display: `${objData.practitionerName}`,
          },
        ],
        valueString: objData["História pessoal e social"],
      };
      break;
    case "História familiar":
      observationBody = {
        resourceType: "Observation",
        meta: {
          profile: [
            "http://fluxmed.com.br/fhir/r5/StructureDefinition/FM-Observation",
          ],
        },
        status: "final",
        code: {
          coding: [
            {
              system: "http://loinc.org",
              code: "10157-6",
              display: "History of family member diseases Narrative",
            },
          ],
          text: "História familiar",
        },
        subject: {
          reference: `Patient/2.16.840.1.113883.13.237-${objData.patientID}`,
        },
        encounter: {
          reference: `Encounter/${objData.encounterID}`,
        },
        issued: dayjs().toISOString(),
        performer: [
          {
            reference: `Practitioner/2.16.840.1.113883.13.237-${objData.practitionerID}`,
            display: `${objData.practitionerName}`,
          },
        ],
        valueString: objData["História familiar"],
      };
      break;
  }

  return JSON.stringify(observationBody);
};

export const auxiliarObservations = {
  generateBodyObservation,
};
